/**
 *
 * Asynchronously loads the component for InstallationInstructions
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ShoutoutValues = lazyLoad(
  () => import('./index'),
  module => module.ShoutoutValues,
);
